module.exports = __webpack_public_path__ + "media/components/assets/icons/admin_crown-be917be91c4d0c77ce3bacd5be97146a.svg";